<div class="modal-header">
    <h4 class="modal-title">{{'manageEndPlates.title' | translate}}</h4>
  </div>
  <div class="modal-body pt-0">
    <div class="modal-body-inner">
      <table class="table table-hover table-striped number-mapping-table fixed-layout" fixedHeader>
        <thead>
          <tr class="d-flex col-12 p-0">
            <th class="d-flex col-11">
              <div class="col-5">{{'manageEndPlates.otherArticleNumber' | translate}}</div>
              <div class="col-5">{{'manageEndPlates.rotated' | translate}}</div>
            </th>
            <th class="col-1 dots">
              <span class="dropdown" dropdown #dropdown="bs-dropdown">
                <a data-toggle="dropdown" dropdownToggle (click)="false"><i class="mdi mdi-dots-vertical c-pointer"></i></a>
                <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                  <li *ngFor="let menuItem of getHeaderMenu()">
                    <a class="dropdown-item" (click)="menuItem.action()">
                      <app-svg-icon [type]="menuItem.icon" size="medium-small"/>
                     <span [innerHTML]="menuItem.label | translate"></span>
                   </a>
                 </li>
                </ul>
              </span>
            </th>
          </tr>
        </thead>
      </table>
        <div class="overflow-xh" style="min-height: 180px" >
          <ng-scrollbar #scroll [visibility]="'hover'">
              <table class="table table-hover table-striped number-mapping-table mb-0">
                <tbody minRowCount>
                  <tr class="d-flex col-12 p-0" *ngFor="let endPlate of endPlateList; let ind = index">
                    <td class="d-flex col-11" *ngIf="endPlate.deleted !== 1">
                      <div class="col-5">{{endPlate.otherArticleNo}}</div>
                      <div class="col-3" *ngIf="endPlate?.rotated"><i class="mdi mdi-check"></i></div>
                      <div class="col-3" *ngIf="!endPlate?.rotated"><i class="mdi mdi-close"></i></div>
                    </td>
                    <td class="col-1 dots" *ngIf="endPlate.deleted !== 1">
                     <span class="dropdown" [dropup]="ind === endPlateList.length - 1 && endPlateList.length > 1" dropdown #dropdown="bs-dropdown">
                       <a data-toggle="dropdown" dropdownToggle (click)="false"><i class="mdi mdi-dots-vertical c-pointer"></i></a>
                       <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                        <li *ngFor="let menuItem of getEndPlateMenu(endPlate)">
                           <a class="dropdown-item" (click)="menuItem.action(endPlate)">
                             <app-svg-icon [type]="menuItem.icon" size="medium-small"/>
                            <span [innerHTML]="menuItem.label | translate"></span>
                          </a>
                        </li>
                       </ul>
                     </span>
                   </td>
                  </tr>
                </tbody>
              </table>
          </ng-scrollbar>
        </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">
      {{ 'global.label.cancel' | translate }}
    </button>
    <button type="submit" class="btn btn-primary" (click)="save()">
      {{ 'global.label.save' | translate }}
    </button>
  </div>
